<mat-toolbar class="main-header">
  <button mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span class="toolbar-title">
    {{ isNew ? "Nuevo comunicado" : (communication?.subject ?? "Comunicado") }}
  </span>
  <span class="toolbar-spacer"></span>
  @if (!isNew && communication && !isEditing) {
    <button
      mat-icon-button
      (click)="startEdit()"
      matTooltip="Editar comunicado"
    >
      <mat-icon>edit</mat-icon>
    </button>
  }
</mat-toolbar>

<block-ui>
  <div class="detail-page">
    <!-- ── Modo: nuevo comunicado ──────────────────── -->
    @if (isNew || isEditing) {
      <form
        #commForm="ngForm"
        (ngSubmit)="isNew ? create(commForm) : update(commForm)"
        novalidate
      >
        <section class="detail-section">
          <h2 class="detail-section__title">Contenido</h2>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Asunto</mat-label>
            <input
              matInput
              name="subject"
              [(ngModel)]="draft.subject"
              required
              maxlength="200"
            />
          </mat-form-field>

          <div class="editor-label">Cuerpo HTML</div>
          <div class="editor-wrap">
            <editor
              apiKey="kt6pgrepxvoc0ybgjgvvrx4hjrcp897kb9195e330z82vzd8"
              name="html"
              [(ngModel)]="draft.html"
              [init]="tinymceConfig"
            ></editor>
          </div>

          <mat-form-field appearance="outline" class="full-width mt-field">
            <mat-label>Texto plano (fallback)</mat-label>
            <textarea
              matInput
              name="text"
              [(ngModel)]="draft.text"
              required
              rows="4"
              maxlength="5000"
            ></textarea>
            <mat-hint
              >Versión sin HTML para clientes de correo que no soportan
              HTML.</mat-hint
            >
          </mat-form-field>
        </section>

        <div class="detail-actions">
          <button
            mat-stroked-button
            type="button"
            (click)="isNew ? goBack() : cancelEdit()"
          >
            Cancelar
          </button>
          <button
            mat-flat-button
            color="primary"
            type="submit"
            [disabled]="commForm.invalid"
          >
            <mat-icon>save</mat-icon>
            {{ isNew ? "Crear comunicado" : "Guardar cambios" }}
          </button>
        </div>
      </form>
    }

    <!-- ── Modo: detalle de comunicado ya enviado ─── -->
    @if (!isNew && communication && !isEditing) {
      <!-- Stats -->
      <section class="detail-section">
        <h2 class="detail-section__title">Estadísticas</h2>
        <div class="stats-grid">
          <div class="stat-box">
            <span class="stat-box__value">{{
              communication.stats.totalRecipients
            }}</span>
            <span class="stat-box__label">Destinatarios</span>
          </div>
          <div class="stat-box stat-box--sent">
            <span class="stat-box__value">{{
              communication.stats.sentCount
            }}</span>
            <span class="stat-box__label">Enviados</span>
          </div>
          <div class="stat-box stat-box--opened">
            <span class="stat-box__value">{{
              communication.stats.openedCount
            }}</span>
            <span class="stat-box__label">
              Aperturas
              <span class="stat-box__pct">
                ({{
                  openRatePercent(
                    communication.stats.openedCount,
                    communication.stats.sentCount
                  )
                }})
              </span>
            </span>
          </div>
          @if (communication.stats.errorCount > 0) {
            <div class="stat-box stat-box--error">
              <span class="stat-box__value">{{
                communication.stats.errorCount
              }}</span>
              <span class="stat-box__label">Errores</span>
            </div>
          }
        </div>
      </section>

      <!-- Info -->
      <section class="detail-section">
        <h2 class="detail-section__title">Información</h2>
        <div class="info-row">
          <span class="info-row__label">Asunto</span>
          <span class="info-row__value">{{ communication.subject }}</span>
        </div>
        <div class="info-row">
          <span class="info-row__label">Estado</span>
          <span class="badge badge--sent">{{ communication.status }}</span>
        </div>
        <div class="info-row">
          <span class="info-row__label">Enviado el</span>
          <span class="info-row__value">{{
            communication.createdAt | date: "dd/MM/yyyy HH:mm"
          }}</span>
        </div>
      </section>

      <!-- Recipients -->
      <section class="detail-section">
        <h2 class="detail-section__title">Destinatarios</h2>
        <div class="recipients-list">
          @for (r of communication.recipients; track r.trackingId) {
            <div class="recipient-row">
              <span class="recipient-row__email">{{ r.email }}</span>
              <div class="recipient-row__badges">
                @if (r.sent) {
                  <span class="badge badge--sent">Enviado</span>
                } @else if (r.error) {
                  <span class="badge badge--error" [matTooltip]="r.error"
                    >Error</span
                  >
                } @else {
                  <span class="badge badge--pending">Pendiente</span>
                }
                @if (r.opened) {
                  <span
                    class="badge badge--opened"
                    [matTooltip]="'Abierto ' + r.openCount + ' veces'"
                  >
                    Abierto × {{ r.openCount }}
                  </span>
                }
              </div>
            </div>
          }
        </div>
      </section>

      <!-- Preview HTML -->
      <section class="detail-section">
        <h2 class="detail-section__title">Vista previa HTML</h2>
        <div class="html-preview" [innerHTML]="communication.html"></div>
      </section>
    }
  </div>
</block-ui>
